import React from 'react';
import PropTypes from 'prop-types';

const HealthcareProfessionalCard = ({ icon, title, description, index }) => {
  return (
    <div
      className="flex flex-col items-center flex-1 text-center md:text-left"
      key={`healthcare-professional-${title || index}`}
    >
      <div className="flex w-15 h-15 md:w-25 md:h-25 px-4 md:px-6 justify-center items-center rounded-full mb-4 md:mb-2.5 bg-blue-30">
        <img
          src={icon}
          alt={title}
          className="w-9 min-h-9 md:w-12 md:min-h-12"
        />
      </div>
      <span className="text-gray-90 text-center font-hg-sans text-xl font-semibold h-8 md:h-16 flex items-center justify-center">
        {title}
      </span>
      <p className="text-gray-90 text-center font-hg-sans text-base font-normal leading-6">
        {description}
      </p>
    </div>
  );
};

HealthcareProfessionalCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  className: PropTypes.string,
  index: PropTypes.number,
};

export default HealthcareProfessionalCard;
